import {
  BRAND_NAME,
  SEO_IMAGE,
  SITE_URL,
  SOCIAL_LINKS,
  getRouteSeo,
} from "@/seo/seoConfig";

type JsonLd = Record<string, unknown>;

/**
 * Build the Schema.org JSON-LD graph for a route.
 *
 * Only types whose required facts are available and truly match the visible
 * content are emitted. Non-indexable routes (e.g. the 404 catch-all) return an
 * empty list.
 */
export function getRouteSchema(pathname: string): JsonLd[] {
  const seo = getRouteSeo(pathname);
  if (!seo.indexable) {
    return [];
  }

  const organization: JsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BRAND_NAME,
    url: `${SITE_URL}/`,
    logo: SEO_IMAGE,
    image: SEO_IMAGE,
    description: seo.description,
    sameAs: SOCIAL_LINKS,
  };

  const website: JsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: BRAND_NAME,
    url: `${SITE_URL}/`,
    inLanguage: ["es", "en"],
  };

  return [organization, website];
}